<template lang="pug">
.section-body
  //- .section-title.m-0
  //-   h5 {{ $t("ui.todays_highlights") }}
  h4.d-flex
    //- | {{ todayDate }}
    div(style="width:265px !important;")
      DateRangePicker(:value="dateRange" @update="getData")
    span.badge.badge-primary(@click="getData()")
      i.fas.fa-sync-alt
  .row
    .col-12
      .card.mb-0
        .card-body            
          .row
            .col-12.col-md-6.col-lg-3
              .card.card-primary
                .card-header
                  h4
                    i.fas.fa-money-bill-alt.mr-1
                    span.text-uppercase.font-weight-bold(:title="$t('ui.deposit')") {{ $t("ui.deposit") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tDeposit,yDeposit)") {{ showPercentage(tDeposit,yDeposit) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_deposit')")
                .card-body
                  .text-value
                    h3(:class="$helpers.fontClassName(tDeposit)" :title="$n(tDeposit, 'currency')") {{ $n(tDeposit, 'currency') }}
                  .text-uppercase.text-muted(:title="$n(depositCount, 'integer')") {{ $t("ui.deposit_count") }} : 
                    span.font-weight-bold {{ $n(depositCount, 'integer') }}
                  .text-uppercase.text-muted(:title="$n(depositPlayer, 'integer')") {{ $t("ui.deposit_player") }} : 
                    span.font-weight-bold {{ $n(depositPlayer, 'integer') }}
            .col-12.col-md-6.col-lg-3
              .card.card-secondary
                .card-header
                  h4
                    i.fas.fa-coins.mr-1
                    span.text-uppercase.font-weight-bold(:title="$t('ui.withdrawal')") {{ $t("ui.withdrawal") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tWithdrawal,yWithdrawal)") {{ showPercentage(tWithdrawal,yWithdrawal) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_withdrawal')")
                .card-body
                  .text-value
                    h3(:class="$helpers.fontClassName(tWithdrawal)" :title="$n(tWithdrawal, 'currency')") {{ $n(tWithdrawal, 'currency') }}
                  .text-uppercase.text-muted(:title="$n(withdrawalCount, 'integer')") {{ $t("ui.withdrawal_count") }} : 
                    span.font-weight-bold {{ $n(withdrawalCount, 'integer') }}
                  .text-uppercase.text-muted(:title="$n(withdrawalPlayer, 'integer')") {{ $t("ui.withdrawal_player") }} : 
                    span.font-weight-bold {{ $n(withdrawalPlayer, 'integer') }}
                  //- .text-uppercase &nbsp;
            .col-12.col-md-6.col-lg-3
              .card.card-primary
                .card-header
                  h4
                    i.fas.fa-dollar-sign.mr-1
                    span.font-weight-bold(:title="$t('ui.turnover')") {{ $t("ui.turnover") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tTurnover,yTurnover)") {{ showPercentage(tTurnover,yTurnover) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_turnover')")
                .card-body                      
                  .text-value
                    h3(:class="$helpers.fontClassName(tTurnover)" :title="$n(tTurnover, 'currency')") {{ $n(tTurnover, 'currency') }}
                  .text-uppercase &nbsp;
                  .text-uppercase &nbsp;
            .col-12.col-md-6.col-lg-3
              .card.card-info
                .card-header
                  h4
                    i.fas.fa-money-bill-wave.mr-1
                    span.font-weight-bold(:title="$t('ui.winlose')") {{ $t("ui.winlose") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tWinlose,yWinlose)") {{ showPercentage(tWinlose,yWinlose) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_winlose')")
                .card-body                    
                  .text-value
                    h3(:class="$helpers.fontClassName(tWinlose)" :title="$n(tWinlose, 'currency')") {{ $n(tWinlose, 'currency') }}
                  .text-uppercase.text-muted(:title="killRate") {{ $t("ui.kill_rate") }} : 
                    span.font-weight-bold {{ killRate }}
                  .text-uppercase &nbsp;              
            .col-12.col-md-6.col-lg-3
              .card.card-warning
                .card-header
                  h4
                    i.fas.fa-users.mr-1
                    span.text-uppercase.font-weight-bold(:title="$t('ui.active_player')") {{ $t("ui.active_player") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tActivePlayer,yActivePlayer)") {{ showPercentage(tActivePlayer,yActivePlayer) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_active_player')")
                .card-body
                  .text-value
                    h3(:class="$helpers.fontClassName(tActivePlayer)" :title="$n(tActivePlayer, 'integer')") {{ $n(tActivePlayer, 'integer') }}
                  .text-uppercase.text-muted(:title="$n(betCount, 'integer')") {{ $t("ui.bet_count") }} : 
                    span.font-weight-bold {{ $n(betCount, 'integer') }}
                  .text-uppercase.text-muted(:title="$n(loginPlayer, 'integer')") {{ $t("ui.login_player") }} : 
                    span.font-weight-bold {{ $n(loginPlayer, 'integer') }}              
            .col-12.col-md-6.col-lg-3
              .card.card-secondary
                .card-header
                  h4
                    i.fas.fa-users.mr-1
                    span.font-weight-bold(:title="$t('ui.total_member')") {{ $t("ui.total_member") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tTotalMember,yTotalMember)") {{ showPercentage(tTotalMember,yTotalMember) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_member')")
                .card-body
                  .text-value
                    h3(:class="$helpers.fontClassName(tTotalMember)" :title="$n(tTotalMember, 'integer')") {{ $n(tTotalMember, 'integer') }}
                  .text-uppercase &nbsp;
                  .text-uppercase &nbsp;
            .col-12.col-md-6.col-lg-3
              .card.card-info
                .card-header
                  h4
                    i.fas.fa-pen.mr-1
                    span.font-weight-bold(:title="$t('ui.verified_signup')") {{ $t("ui.verified_signup") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tVerified,yVerified)") {{ showPercentage(tVerified,yVerified) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_verfied_signup')")
                .card-body
                  .text-value.row.col-sm-12
                    h3(:class="$helpers.fontClassName(tVerified)" :title="$n(tVerified, 'integer')") {{ $n(tVerified, 'integer') }}
                    h3 &nbsp;/&nbsp;
                    h3(:class="$helpers.fontClassName(tSignup)" :title="$n(tSignup, 'integer')") {{ $n(tSignup, 'integer') }}
                  .text-uppercase &nbsp;
                  .text-uppercase &nbsp;
            .col-12.col-md-6.col-lg-3
              .card.card-warning
                .card-header
                  h4
                    i.fas.fa-user.mr-1
                    span.font-weight-bold(:title="$t('ui.total_referee')") {{ $t("ui.total_referee") }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tTotalReferee,yTotalReferee)") {{ showPercentage(tTotalReferee,yTotalReferee) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_referee')")
                .card-body
                  .text-value
                    h3(:class="$helpers.fontClassName(tTotalReferee)" :title="$n(tTotalReferee, 'integer')") {{ $n(tTotalReferee, 'integer') }}
                  .text-uppercase &nbsp;
                  .text-uppercase &nbsp;              
            .col-12.col-md-6.col-lg-3
              .card.card-primary
                .card-header
                  h4
                    i.fa.fa-calendar.mr-1
                    span.font-weight-bold(:title="$tc('ui.ftd', 1)") {{ $tc("ui.ftd", 1) }}
                    span.badge.float-right.ml-2(v-if="isToday()" :class="showBadge(tFTD,yFTD)") {{ showPercentage(tFTD,yFTD) }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_ftd')")
                .card-body
                  .text-value
                    h3(:class="$helpers.fontClassName(tFTD)" :title="$n(tFTD, 'currency')") {{ $n(tFTD, 'currency') }}
                  .text-uppercase.text-muted(:title="$n(ftdCount, 'integer')") {{ $t("ui.ftd_count") }} : 
                    span.font-weight-bold {{ $n(ftdCount, 'integer') }}
                .text-uppercase &nbsp;
                .text-uppercase &nbsp;              
            .col-12.col-md-6.col-lg-3(v-if="isOperator && showActionButton('systembalance')")
              .card.card-warning
                .card-header
                  h4
                    i.fas.fa-user.mr-1
                    span.font-weight-bold(:title="$t('ui.total_player_balance')") {{ $t("ui.total_player_balance") }}
                    //- span.badge.badge-info.float-right {{ currentMonth }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(:title="$t('ui.total_player_balance')")
                .card-body
                  .text-value
                    h3(:class="$helpers.fontClassName(systemBalance)" :title="$n(systemBalance, 'integer')") {{ $n(systemBalance, 'integer') }}
                  .text-uppercase &nbsp;
                  .text-uppercase &nbsp;
            .col-12.col-md-6.col-lg-3
              .card.card-secondary
                .card-header
                  h4
                    i.fas.fa-money-bill.mr-1
                    span.font-weight-bold.title(:title="$t('ui.free_credit_withdrawal_amount')") {{ $t("ui.fc_withdrawal_amount") }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.free_credit_withdrawal_amount')")
                .card-body
                  .text-value.row.col-sm-12
                    h3(:class="$helpers.fontClassName(tWithdrawalFree)" :title="$n(tWithdrawalFree, 'currency')") {{ $n(tWithdrawalFree, 'currency') }}
                  .text-uppercase &nbsp;
                  .text-uppercase &nbsp;

          .row
            .col-12.col-md-6.col-lg-6
              .card.card-success
                .card-body
                  .row.m-1
                    .ml-auto
                      i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_winlose_chart')")
                  .animated.fadeIn.col-12(style="background: white;")
                    line-chart(:chartData="secondDataSet" :options="chartOptions")
            .col-12.col-md-6.col-lg-6
              .card.card-danger
                .card-body
                  .row.m-1
                    .ml-auto
                      i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_turnover_chart')")
                  .animated.fadeIn.col-12(style="background: white;")
                    line-chart(:chartData="firstDataSet" :options="chartOptions")           
          
          .row
            .col-sm-12.col-md-6.col-lg-3
              .card.card-info
                .card-header
                  h4
                    i.fas.fa-list-ol.mr-1
                    span.font-weight-bold(:title="$t('ui.top_winner')") {{ $t("ui.top_winner") }}
                    //- span.badge.badge-info.float-right {{ currentMonth }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_top_winner')")
                .card-body
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle(width="100%" v-columns-resizable)
                    thead.thead-light
                      tr
                        th.text-center(width="15%")
                          span #
                        th(width="45%")
                          span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                        th(width="40%")
                          span(:title="$t('ui.winner')") {{ $t("ui.winner") }}
                    tbody
                      tr(v-if="topWinnerList.length == 0")
                        td(colspan="3").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in topWinnerList")
                        td.text-center
                          span {{ index + 1 }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
            .col-sm-12.col-md-6.col-lg-3
              .card.card-info
                .card-header
                  h4
                    i.fas.fa-list-ol.mr-1
                    span.font-weight-bold(:title="$t('ui.top_loser')") {{ $t("ui.top_loser") }}
                    //- span.badge.badge-info.float-right {{ currentMonth }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_top_loser')")
                .card-body
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle(width="100%")
                    thead.thead-light
                      tr
                        th.text-center(width="15%")
                          span #
                        th(width="45%")
                          span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                        th(width="40%")
                          span(:title="$t('ui.loser')") {{ $t("ui.loser") }}
                    tbody
                      tr(v-if="topLoserList.length == 0")
                        td(colspan="3").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in topLoserList")
                        td.text-center
                          span {{ index + 1 }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
            .col-sm-12.col-md-6.col-lg-3
              .card.card-info
                .card-header
                  h4
                    i.fas.fa-list-ol.mr-1
                    span.font-weight-bold(:title="$t('ui.top_deposit')") {{ $t("ui.top_deposit") }}
                    //- span.badge.badge-info.float-right {{ currentMonth }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_top_deposit')")
                .card-body
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle(width="100%")
                    thead.thead-light
                      tr
                        th.text-center(width="15%")
                          span #
                        th(width="45%")
                          span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                        th(width="40%")
                          span(:title="$t('ui.amount')") {{ $t("ui.amount") }}
                    tbody
                      tr(v-if="topDepositList.length == 0")
                        td(colspan="3").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in topDepositList")
                        td.text-center
                          span {{ index + 1 }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
            .col-sm-12.col-md-6.col-lg-3
              .card.card-info
                .card-header
                  h4
                    i.fas.fa-list-ol.mr-1
                    span.font-weight-bold(:title="$t('ui.top_withdrawal')") {{ $t("ui.top_withdrawal") }}
                    //- span.badge.badge-info.float-right {{ currentMonth }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_top_withdrawal')")
                .card-body
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle(width="100%")
                    thead.thead-light
                      tr
                        th.text-center(width="15%")
                          span #
                        th(width="45%")
                          span(:title="$t('ui.account_id')") {{ $t("ui.account_id") }}
                        th(width="40%")
                          span(:title="$t('ui.amount')") {{ $t("ui.amount") }}
                    tbody
                      tr(v-if="topWithdrawalList.length == 0")
                        td(colspan="3").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in topWithdrawalList")
                        td.text-center
                          span {{ index + 1 }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
          .row
            .col-sm-12.col-md-12.col-lg-6
              .card.card-info
                .card-header
                  h4
                    i.fas.fa-list-ol.mr-1
                    span.font-weight-bold(:title="$t('ui.top_promotion')") {{ $t("ui.top_promotion") }}
                    //- span.badge.badge-info.float-right {{ currentMonth }}
                  .card-header-action
                    i.fa.fa-lg.fa-info-circle.text-warning(data-toggle="tooltip" :title="$t('message.d_top_promotion')")
                .card-body
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle(width="100%")
                    thead.thead-light
                      tr
                        th.text-center(width="10%")
                          span #
                        th(width="20%")
                          span(:title="$t('ui.id')") {{ $t("ui.id") }}
                        th(width="50%")
                          span(:title="$t('ui.name')") {{ $t("ui.name") }}
                        th(width="20%")
                          span(:title="$t('ui.claim_frequency')") {{ $t("ui.claim_frequency") }}
                    tbody
                      tr(v-if="topPromotionList.length == 0")
                        td(colspan="4").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in topPromotionList")
                        td.text-center
                          span {{ index + 1 }}
                        td
                          span(:title="item.promotion_id") {{ item.promotion_id }}
                        td
                          span(:title="item.promotion_name") {{ item.promotion_name }}
                        td
                          span(:title="$n(item.claim_frequency, 'integer')") {{ $n(item.claim_frequency, 'integer') }}              

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import LineChart from '@/lineChart.js';
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    LineChart,
    DateRangePicker
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    working_date: null,
    dateRange: {
      startDate: null,
      endDate: null,
    },
    tDeposit: null,
    yDeposit: null,
    depositCount: null,
    depositPlayer: null,
    tWithdrawal: null,
    yWithdrawal: null,
    withdrawalCount: null,
    withdrawalPlayer: null,
    tTurnover: null,
    yTurnover: null,
    tWinlose: null,
    yWinlose: null,
    killRate: null,
    tActivePlayer: null,
    yActivePlayer: null,
    betCount: null,
    loginPlayer: null,
    tTotalMember: null,
    yTotalMember: null,
    tVerified: null,
    yVerified: null,
    tSignup: null,
    ySignup: null,
    tTotalReferee: null,
    yTotalReferee: null,
    tFTD: null,
    yFTD: null,
    ftdCount: null,


    topWinnerList: [],
    topLoserList: [],
    topDepositList: [],
    topWithdrawalList: [],
    topPromotionList: [],
    paymentGatewayList: [],

    
    firstDataSet: null,
    secondDataSet: null,
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false
    },
    dateLabel: [],
    depositList: [],
    validTurnoverList: [],
    winloseList: [],
    withdrawalList: [],
    
    systemBalance: 0,
    tWithdrawalFree: 0
  }),
  computed: {
    getLanguage() {
      return this.$store.getters.language;
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    currentMonth() {
      return this.$moment(new Date).format("MMMM");
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    // todayDate() {
    //   switch(this.getLanguage) {
    //     case "zh":
    //       return this.$moment().locale('zh-cn').format('dddd, YYYY-MM-DD')
    //     default:
    //       return this.$moment().format('dddd, YYYY-MM-DD')
    //   }
    // },
  },
  mounted: function() {
    if(this.$store.getters.sessionToken) {
      this.dateRange.startDate = this.$moment(new Date).format("YYYY-MM-DD");
      this.dateRange.endDate = this.$moment(new Date).format("YYYY-MM-DD");

      if (this.isToday()) {
        this.getDashboard();
      } else {
        this.getDashboardRange();
      }
      if(this.isOperator && this.showActionButton('systembalance'))
        this.getSystemBalance();
    }
  },
  methods: {
    showActionButton(action) {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          var roles = this.$store.getters.accountAuthority[0].authority_option;
          roles =  roles && roles.length > 0 ? roles.split(',') : [];
          if (roles.includes(action))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        return true;
      }
    },
    clearData: function() {
      this.dateLabel = [];
      this.validTurnoverList = [];
      this.winloseList = [];
      this.depositList = [];
      this.withdrawalList = [];

      this.integrateChartData()

      this.tDeposit = 0;
      this.depositCount = 0;
      this.tWithdrawal = 0;
      this.tWithdrawalFree = 0;
      this.withdrawalCount = 0;
      this.tWinlose = 0;
      this.tTurnover = 0;
      this.tVerified = 0;
      this.tSignup = 0;
      this.tTotalReferee = 0;
      this.tFTD = 0;
      this.ftdCount = 0;
      this.killRate = null
      this.depositPlayer = 0      
      this.tActivePlayer = 0
      this.withdrawalPlayer = 0
      this.betCount = 0
      this.loginPlayer = 0
      this.tTotalMember = 0
      this.topWinnerList = []
      this.topLoserList = []
      this.topDepositList = []
      this.topWithdrawalList = []
      this.topPromotionList = []
    },
    isToday() {
      return this.dateRange.startDate === this.dateRange.endDate
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 30)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      if(currentValue) {
        this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      }

      if (this.isToday()) {
        this.getDashboard();
      } else {
        this.getDashboardRange();
      }
    },
    getDashboard: function() {
      if(this.isOperator) {
        let url = config.dashboardOPUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.$store.getters.accountId,
          working_date: this.dateRange.startDate
          // working_date: this.$moment().format('YYYY-MM-DD')
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearData();
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  if(response.data.ds.summary.length > 0) {
                    var datatable = response.data.ds.summary;
                    for (var i = datatable.length - 1; i >= 0 ; i--) {
                      this.dateLabel.push(this.$moment(datatable[i]["working_date"]).format("DD"));
                      this.validTurnoverList.push(datatable[i]["valid_turnover"]);
                      this.winloseList.push(datatable[i]["winlose"]);
                      this.depositList.push(datatable[i]["deposit_amount"]);
                      this.withdrawalList.push(datatable[i]["withdrawal_amount"]);
                    }
                    this.integrateChartData()
                    
                    this.tDeposit = datatable[0]["deposit_amount"]
                    this.yDeposit = datatable[1]["deposit_amount"]
                    this.depositCount = datatable[0]["deposit_count"]

                    this.tWithdrawal = datatable[0]["withdrawal_amount"]
                    this.yWithdrawal = datatable[1]["withdrawal_amount"]
                    this.withdrawalCount = datatable[0]["withdrawal_count"]

                    this.tWinlose = datatable[0]["winlose"]
                    this.yWinlose = datatable[1]["winlose"]

                    this.tTurnover = datatable[0]["valid_turnover"]
                    this.yTurnover = datatable[1]["valid_turnover"]

                    if(this.tWinlose == 0 || this.tTurnover == 0) {
                      this.killRate = "N/A"
                    } else {
                      this.killRate = (this.tWinlose / this.tTurnover).toFixed(2) + "%"
                    }

                    this.tVerified = datatable[0]["verified_count"]
                    this.yVerified = datatable[1]["verified_count"]

                    this.tSignup = datatable[0]["signup_count"]
                    this.ySignup = datatable[1]["signup_count"]

                    this.tTotalReferee = datatable[0]["referee_count"]
                    this.yTotalReferee = datatable[1]["referee_count"]

                    this.tFTD = datatable[0]["ftd_amount"]
                    this.yFTD = datatable[1]["ftd_amount"]
                    this.ftdCount = datatable[0]["ftd_count"]
                  }

                  if (response.data.ds.member_count.length > 0) {
                    this.depositPlayer = response.data.ds.member_count[0].deposit_player_count
                    this.withdrawalPlayer = response.data.ds.member_count[0].withdrawal_player_count
                  }

                  if (response.data.ds.today_active.length > 0) {
                    this.tActivePlayer = response.data.ds.today_active[0].active_player
                    this.betCount = response.data.ds.today_active[0].total_bet_count
                  }

                  if (response.data.ds.yesterday_active.length > 0) {
                    this.yActivePlayer = response.data.ds.yesterday_active[0].active_player
                  }

                  if (response.data.ds.login_count.length > 0) {
                    this.loginPlayer = response.data.ds.login_count[0].login_count
                  }

                  if (response.data.ds.today_member.length > 0) {
                    this.tTotalMember = response.data.ds.today_member[0].total_verified_count
                  }

                  if (response.data.ds.yesterday_member.length > 0) {
                    this.yTotalMember = response.data.ds.yesterday_member[0].total_verified_count
                  }

                  if (response.data.ds.top_winner.length > 0) {
                    this.topWinnerList = response.data.ds.top_winner;
                  }

                  if (response.data.ds.top_loser.length > 0) {
                    this.topLoserList = response.data.ds.top_loser;
                  }

                  if (response.data.ds.top_deposit.length > 0) {
                    this.topDepositList = response.data.ds.top_deposit;
                  }

                  if (response.data.ds.top_withdrawal.length > 0) {
                    this.topWithdrawalList = response.data.ds.top_withdrawal;
                  }

                  if (response.data.ds.top_promo.length > 0) {
                    this.topPromotionList = response.data.ds.top_promo;
                  }

                  if(response.data.ds.free_credit_withdrawal.length > 0) {
                    this.tWithdrawalFree = response.data.ds.free_credit_withdrawal[0].withdrawal_amount_free
                  }
                } else {
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  }
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearData();
      }
    },
    getDashboardRange: function() {
      if(this.isOperator) {
        if (this.checkDateRange()) {
          let url = config.dashboardOPRangeUrl();

          var json = {
            action_by: this.$store.getters.loginId,
            auth_token: this.$store.getters.sessionToken,
            operator_id: this.$store.getters.accountId,
            start_date: this.dateRange.startDate,
            end_date: this.dateRange.endDate
          };

          this.loading = true;
          this.$http.post(url, json).then(
            function(response) {
              this.clearData();
              this.loading = false;
              // Success
              try {
                if (response) {
                  this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                  this.feedback.status = response.data.statusdesc;

                  if (this.feedback.success == true) {
                    if(response.data.ds.summary.length > 0) {
                      var datatable = response.data.ds.summary;
                      for (var i = datatable.length - 1; i >= 0 ; i--) {
                        this.dateLabel.push(this.$moment(datatable[i]["working_date"]).format("DD"));
                        this.validTurnoverList.push(datatable[i]["valid_turnover"]);
                        this.winloseList.push(datatable[i]["winlose"]);
                        this.depositList.push(datatable[i]["deposit_amount"]);
                        this.withdrawalList.push(datatable[i]["withdrawal_amount"]);

                        this.tDeposit += datatable[i]["deposit_amount"]
                        this.depositCount += datatable[i]["deposit_count"]
                        this.tWithdrawal += datatable[i]["withdrawal_amount"]
                        this.withdrawalCount += datatable[i]["withdrawal_count"]
                        this.tWinlose += datatable[i]["winlose"]
                        this.tTurnover += datatable[i]["valid_turnover"]
                        this.tVerified += datatable[i]["verified_count"]
                        this.tSignup += datatable[i]["signup_count"]
                        this.tTotalReferee += datatable[i]["referee_count"]
                        this.tFTD += datatable[i]["ftd_amount"]
                        this.ftdCount += datatable[i]["ftd_count"]
                      }
                      this.integrateChartData()
                      
                      // this.tDeposit = datatable[0]["deposit_amount"]
                      // this.yDeposit = datatable[1]["deposit_amount"]
                      // this.depositCount = datatable[0]["deposit_count"]

                      // this.tWithdrawal = datatable[0]["withdrawal_amount"]
                      // this.yWithdrawal = datatable[1]["withdrawal_amount"]
                      // this.withdrawalCount = datatable[0]["withdrawal_count"]

                      // this.tWinlose = datatable[0]["winlose"]
                      // this.yWinlose = datatable[1]["winlose"]

                      // this.tTurnover = datatable[0]["valid_turnover"]
                      // this.yTurnover = datatable[1]["valid_turnover"]

                      if(this.tWinlose == 0 || this.tTurnover == 0) {
                        this.killRate = "N/A"
                      } else {
                        this.killRate = (this.tWinlose / this.tTurnover).toFixed(2) + "%"
                      }

                      // this.tVerified = datatable[0]["verified_count"]
                      // this.yVerified = datatable[1]["verified_count"]

                      // this.tSignup = datatable[0]["signup_count"]
                      // this.ySignup = datatable[1]["signup_count"]

                      // this.tTotalReferee = datatable[0]["referee_count"]
                      // this.yTotalReferee = datatable[1]["referee_count"]

                      // this.tFTD = datatable[0]["ftd_amount"]
                      // this.yFTD = datatable[1]["ftd_amount"]
                      // this.ftdCount = datatable[0]["ftd_count"]
                    }

                    if (response.data.ds.member_count.length > 0) {
                      this.depositPlayer = response.data.ds.member_count[0].deposit_player_count
                      this.withdrawalPlayer = response.data.ds.member_count[0].withdrawal_player_count
                    }

                    if (response.data.ds.today_active.length > 0) {
                      this.tActivePlayer = response.data.ds.today_active[0].active_player
                      this.betCount = response.data.ds.today_active[0].total_bet_count
                    }

                    if (response.data.ds.yesterday_active.length > 0) {
                      this.yActivePlayer = response.data.ds.yesterday_active[0].active_player
                    }

                    if (response.data.ds.login_count.length > 0) {
                      this.loginPlayer = response.data.ds.login_count[0].login_count
                    }

                    if (response.data.ds.today_member.length > 0) {
                      this.tTotalMember = response.data.ds.today_member[0].total_verified_count
                    }

                    if (response.data.ds.yesterday_member.length > 0) {
                      this.yTotalMember = response.data.ds.yesterday_member[0].total_verified_count
                    }

                    if (response.data.ds.top_winner.length > 0) {
                      this.topWinnerList = response.data.ds.top_winner;
                    }

                    if (response.data.ds.top_loser.length > 0) {
                      this.topLoserList = response.data.ds.top_loser;
                    }

                    if (response.data.ds.top_deposit.length > 0) {
                      this.topDepositList = response.data.ds.top_deposit;
                    }

                    if (response.data.ds.top_withdrawal.length > 0) {
                      this.topWithdrawalList = response.data.ds.top_withdrawal;
                    }

                    if (response.data.ds.top_promo.length > 0) {
                      this.topPromotionList = response.data.ds.top_promo;
                    }
                    if(response.data.ds.free_credit_withdrawal.length > 0) {
                      this.tWithdrawalFree = response.data.ds.free_credit_withdrawal[0].withdrawal_amount_free
                    }
                  } else {
                    if (this.feedback.status != 'permission_denied') {
                      if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                    }
                    else {
                      this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                    }
                  }
                }
              } catch (error) {
                this.feedback.success = false;
                this.feedback.status = errorTags.request.failed;
                this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            },
            function(response) {
              this.loading = false;
              // Error
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          );
        } else {
          this.clearData();
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
        }
      } else {
        this.clearData();
      }
    },
    getSystemBalance: function() {
      let url = config.systemBalanceUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        audit_by: this.$store.getters.loginId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;

              if (this.feedback.success == true) {
                this.systemBalance = response.data.dt.length > 0 ? response.data.dt[0].system_balance : 0;
              } else {
                if (this.feedback.status != 'permission_denied') {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
                else {
                  this.$helpers.showToast(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    redirectTo: function(link) {
      this.$router.push(link);
    },
    showBadge(today, yesterday) {
      if (today == null || yesterday == null || today === "" || yesterday === "") {
        return ""; 
      }

      if (yesterday === 0) {
        return "badge-warning"; 
      }

      const percentageIncrease = ((today - yesterday) / Math.abs(yesterday)) * 100;

      if (percentageIncrease > 0) {
        return "badge-success";
      } else if (percentageIncrease < 0) {
        return "badge-danger";
      } else {
        return "badge-info"; 
      }
    },
    showPercentage(today, yesterday) {
      if (today == null || yesterday == null || today === "" || yesterday === "") {
        return ""; 
      }

      if (yesterday === 0) {
        return "N/A";
      }
      const percentageIncrease = ((today - yesterday) / Math.abs(yesterday)) * 100;
      
      const formattedResult = percentageIncrease > 0 
        ? `+${percentageIncrease.toFixed(2)}%`
        : `${percentageIncrease.toFixed(2)}%`;

      return formattedResult;
    },
    integrateChartData: function () {
      // if(this.firstDataSet) {
      //   this.firstDataSet.destroy()
      // }

      // if(this.secondDataSet) {
      //   this.secondDataSet.destroy()
      // }

      this.firstDataSet = {
        labels: this.dateLabel,
        datasets: [
          {
            label: this.$t("ui.turnover"),
            backgroundColor: '#52BE80',
            data: this.validTurnoverList
          },
          {
            label: this.$t("ui.deposit"),
            backgroundColor: '#26C6DA',
            data: this.depositList
          }
        ]
      };
      this.secondDataSet = {
        labels: this.dateLabel,
        datasets: [
          {
            label: this.$t("ui.winlose"),
            backgroundColor: '#FFF176',
            data: this.winloseList
          },
          {
            label: this.$t("ui.withdrawal"),
            backgroundColor: '#FFB74D',
            data: this.withdrawalList
          }
        ]
      };
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<!-- <style lang="scss" scoped>

.badge {
  padding: 2.5px 4px !important;
}
.text-value {
  h1 {
    overflow:hidden !important;
    text-overflow:ellipsis !important;
    white-space: nowrap !important;
  }
}
</style> -->